import styled from "styled-components";

const ReceiptsPageStyled = styled.div`

`;

export default ReceiptsPageStyled;